import { useField } from 'formik'
import { BrandPlanTactic } from 'types'
import { CheckboxGroup } from 'components/CheckboxGroup/CheckboxGroup'
import { Checkbox } from 'components/CheckboxGroup/Checkbox'
import Styles from './CrosspostTactics.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { InstagramBrand } from 'blaze-ui/icons/24'
import { TikTokBrand, YouTubeBrand } from 'blaze-ui/icons'
import cx from 'classnames'
import { useIsOnboardingRedesign } from 'hooks/useIsOnboardingRedesign'
import { InstagramReelsBrand } from 'blaze-ui/icons/30'

interface VideoCrosspostTacticsProps {
  className?: string
  applyRedesign?: boolean
}

export const VideoCrosspostTactics = ({ className, applyRedesign = false }: VideoCrosspostTacticsProps = {}) => {
  const isOnboardingRedesign = useIsOnboardingRedesign() && applyRedesign
  const [{ value }, , { setValue }] = useField<BrandPlanTactic[]>('tactics')
  const textVariant = isOnboardingRedesign ? 'primary' : 'largeList'
  return (
    <CheckboxGroup
      value={value}
      onChange={(value) => setValue(value as BrandPlanTactic[])}
      className={cx(Styles.group, className, { [Styles.applyRedesign]: isOnboardingRedesign })}
      aria-label="Video crosspost platforms"
    >
      <Checkbox
        value={BrandPlanTactic.InstagramReel}
        size={20}
        color="var(--selected-fill)"
        aria-label={BrandPlanTactic.InstagramReel}
        className={cx(Styles.checkbox, { [Styles.applyRedesign]: isOnboardingRedesign })}
      >
        <div className={Styles.checkboxLabel}>
          {isOnboardingRedesign ? <InstagramReelsBrand size={20} /> : <InstagramBrand size={20} />}
          <Text variant={textVariant} color="var(--dark-80)">
            Instagram Reels
          </Text>
        </div>
      </Checkbox>
      <Checkbox
        value={BrandPlanTactic.YouTube}
        size={20}
        color="var(--selected-fill)"
        aria-label={BrandPlanTactic.YouTube}
        className={cx(Styles.checkbox, { [Styles.applyRedesign]: isOnboardingRedesign })}
      >
        <div className={Styles.checkboxLabel}>
          <YouTubeBrand size={20} />
          <Text variant={textVariant} color="var(--dark-80)">
            YouTube Shorts
          </Text>
        </div>
      </Checkbox>
      <Checkbox
        value={BrandPlanTactic.TikTok}
        size={20}
        color="var(--selected-fill)"
        aria-label={BrandPlanTactic.TikTok}
        className={cx(Styles.checkbox, { [Styles.applyRedesign]: isOnboardingRedesign })}
      >
        <div className={Styles.checkboxLabel}>
          <TikTokBrand size={20} />
          <Text variant={textVariant} color="var(--dark-80)">
            TikTok Posts
          </Text>
        </div>
      </Checkbox>
    </CheckboxGroup>
  )
}
